.back {
  margin-bottom: 16px;
}

.card {
  margin-bottom: 16px;
}

.userHeader {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
}

.userTitle {
  margin: 0;
  font-size: 20px;
  color: var(--ant-color-text-heading);
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.warningIcon {
  color: var(--ant-color-warning);
}

.clearList {
  padding-left: 20px;
  margin: 12px 0;
}

.confirmHint {
  margin: 16px 0 8px;
  font-weight: 500;
}
